import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ViewableImageWebPackge } from '../models/viewable-image.model';
import { BaseService } from './base.service';

@Injectable()
export class ImageService extends BaseService {

  constructor(protected http: Http) {
    super(http);
  }

  async getAllImageTypes(patientId: string): Promise<any> {
    return this.get('image/imageTypes/' + patientId);
  }

  async getAllUploadComments(patientId: string): Promise<string[]> {
    return this.get('image/uploadComments/' + patientId);
  }

  async getViewableImages(imageId: string): Promise<ViewableImageWebPackge> {
    return this.get('image/viewable/' + imageId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/image.service.ts